import formatPrice from 'utils/formatPrice';

const getOrderLineCharge = ({ orderLine, value, index, part }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine && indexOrderLine.Charge) {
      const charge = typeof indexOrderLine.Charge === 'number'
        ? formatPrice(indexOrderLine.Charge, false) : indexOrderLine.Charge;
      switch (part) {
        case 'dollars':
          return charge.split('.')[0];
        case 'cents':
          return charge.split('.')[1];
        default:
          return charge;
      }
    }
    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      const charge = typeof item.Charge === 'number'
        ? formatPrice(item.Charge, false) : item.Charge;
      switch (part) {
        case 'dollars':
          return charge.split('.')[0];
        case 'cents':
          return charge.split('.')[1];
        default:
          return charge;
      }
    }).join(', ')
    : null;
};

export default getOrderLineCharge;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineCharge.js